import { BaseRouteState, RoutingConfig } from '../lib/routing/types';

const defaultRouteState: BaseRouteState = {
    page: null,
    companyTopics: [],
    services: [],
    solutions: [],
    technologies: [],
};

const enabledRefinementLists = ['companyTopics', 'services', 'solutions', 'technologies'];

const basePath = 'about/journal';

export const journalRoutingConfig: Omit<RoutingConfig<typeof basePath>, 'index'> = {
    defaultRouteState,
    enabledRefinementLists,
    basePath,
};
